import { DEBUG, KEYCLOAK_ACCOUNT_URI, RESTRICTED_MAIL_DOMAINS } from "./config";
import { DomHelper } from "./domHelper";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { Util } from "./util";
import { getAppCardNode } from "./appCardDefault";
export function publicRouter(url) {
    if (DEBUG)
        console.log("-->publicRouter called", url);
    const params = new URLSearchParams(url.search);
    const action = params.get('action');
    if (DEBUG)
        console.log("action", action);
    DomHelper.disableDefaultLogin();
    DomHelper.disableDefaultNavigation();
    switch (action) {
        case 'register':
            renderRegisterForm(params);
            break;
        case 'cmdb':
            renderCMDBForm();
            break;
        default:
            renderDefault();
    }
}
function renderRegisterForm(params) {
    if (DEBUG)
        console.log("-->renderRegisterForm");
    DomHelper.setHeaderTitle("open-diakonie.de", "Registrierung");
    const id = params.get('id');
    if (DEBUG)
        console.log("id", id);
    if (!id)
        return;
    getBackendData("", `/public/invitation/${Util.urlEncode(id)}`, "GET", "application/json", "", function (response) {
        const responseData = JSON.parse(response.target.response);
        console.log("invitation", responseData);
        if (response.target.status === 404) {
            renderNotFound();
        }
        else {
            renderRegisterInputForm(responseData[0]);
        }
    });
}
function renderNotFound() {
    const appNode = document.querySelector('main');
    if (appNode) {
        appNode.innerHTML = "<h1>Invitation not found</h1>";
    }
}
function handleClickOpen(injectNode, event, username, s, param5, idString) {
}
function renderTOTPInputForm(appNode, invitation) {
    const templateApp = {
        cn: "",
        consentRequired: false,
        odAppConfig: "{\"hidefooter\":true}",
        odAppIcon: "fa-light fa-user-secret",
        odAppIconType: "font",
        odAppTitle: "TOTP Einrichtung",
        odAppType: "totp"
    };
    let iconClassesSection = ['rudi-app-group'];
    const section = DomHelper.appendNode(appNode, 'section', iconClassesSection, [{
            attr: "id",
            value: "totp_section"
        }]);
    const cardNode = getAppCardNode(section, templateApp, "public", {
        favorites: [],
        logInteraction: false,
        theme: ""
    }, "", false, [], null, (event) => {
        if (DEBUG)
            console.log("TOTP handle Click");
        let injectNode = cardNode.querySelector(`.rudi-app-inject`);
        handleClickOpen(injectNode, event, "public", "", {}, "idString");
    });
    cardNode.classList.add('app-open');
    cardNode.classList.remove('rudi-max-height');
    let injectNode = cardNode.querySelector(`.rudi-app-inject`);
    injectNode.classList.remove('rudi-app-inject');
    injectNode.classList.remove('disabled');
    injectNode.classList.add('rudi-app-interaction');
    DomHelper.appendNode(injectNode, 'p', [], [], "Bitte scannen Sie mit Ihrer Authenticator APP (z.B. FreeOTP oder Google Authenticator) den QR-Code.<br>Tragen Sie anschließend den generierten Code in das Feld ein.");
    if (!invitation.qrcode)
        return;
    const username = invitation.username;
    const qrImg = DomHelper.appendNode(injectNode, "img", ["img-fluid", "mb-3"], [{
            attr: "src",
            value: invitation.qrcode
        }]);
    qrImg.style.maxWidth = "200px";
    const formGroup = DomHelper.appendNode(injectNode, "div", ["form-group", "mt-3"], []);
    DomHelper.appendNode(formGroup, "label", ["form-label"], [], "Verifizierungs-Code");
    const tokenInput = DomHelper.appendNode(formGroup, "input", ["form-control", "text-center"], [
        { attr: "type", value: "text" },
        { attr: "maxlength", value: "6" }
    ]);
    tokenInput.style.fontSize = "1.5rem";
    tokenInput.style.letterSpacing = "0.5rem";
    const verifyBtn = DomHelper.appendNode(injectNode, "button", ["btn", "btn-primary", "mt-3", "w-100"], [], "Verifizieren & Aktivieren");
    verifyBtn.addEventListener("click", () => {
        const token = tokenInput.value;
        if (token.length !== 6) {
            DomHelper.alertMessage("Bitte geben Sie einen 6-stelligen Code ein.");
            return;
        }
        const oldInnerHTML = injectNode.innerHTML;
        DomHelper.appendSpinner(injectNode);
        sendBackendData('', `/public/${username}/totp/verify`, "POST", "application/json", "", { token: token }, (response) => {
            DomHelper.removeSpinner(injectNode);
            const result = JSON.parse(response.target.response);
            if (result.valid) {
                injectNode.innerHTML = `
                    <div class="alert alert-success">
                        <i class="fa-solid fa-check-circle fa-2x mb-2"></i>
                        <p>TOTP wurde erfolgreich aktiviert!</p>
                    </div>
                `;
                sendBackendData('', `/public/invitation/${invitation.id}`, "POST", 'application/json', "", { "completed": true }, (response) => {
                    console.log("response", response);
                    const responseData = JSON.parse(response.target.response);
                });
            }
            else {
                DomHelper.removeSpinner(injectNode);
                injectNode.innerHTML = oldInnerHTML;
                DomHelper.showMessage({
                    appcn: "",
                    appdn: "",
                    duration: 5000,
                    header: "Error",
                    icon: "fa-circle-exclamation",
                    message: 'Ungültiger Code. Bitte versuchen Sie es erneut.',
                    type: 'error',
                    version: ""
                }, null, "");
            }
        });
    });
}
function renderRegisterInputForm(invitation) {
    const appNode = document.querySelector('main');
    if (appNode) {
        if (invitation.tokenid) {
            renderTOTPInputForm(appNode, invitation);
        }
        else {
            DomHelper.appendNode(appNode, 'h1', [], [], "Sie wurden eingeladen einen Account zu erstellen.");
            DomHelper.appendNode(appNode, 'p', [], [], "Bitte ergänzen Sie Ihre Daten und klicken Sie auf 'Registrieren'.<br>Danach werden Sie auf die Startseite des Chats weiteregeleitet. Dort können Sie sich mit Ihren Zugansdaten anmelden.");
            const formNode = DomHelper.appendNode(appNode, "form", ['not-disabled'], [{ attr: "id", value: "rudi-profile-form" },
                { attr: "rudi-username", value: invitation.username + "" }
            ]);
            const givenName = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'givenName', 'Vorname', "", [], false);
            const surName = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'sn', 'Nachname', "", [], false);
            const mail = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'mail', 'E-Mail-Adresse', invitation.mail, [], invitation.mail != undefined && invitation.mail != "");
            const phone = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'phone', 'Mobil Nummer', invitation.phone, [], invitation.phone != "" && invitation.phone != undefined);
            const password1 = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'password1', 'Passwort', "", [], false, undefined, false, 'password');
            const password2 = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'password2', 'Passwort bestätigen', "", [], false, undefined, false, 'password');
            const sectionButton = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
            DomHelper.appendNode(sectionButton, 'button', ['btn', 'btn-primary', 'mt-2'], [{
                    attr: "type",
                    value: "submit"
                }], "Registrieren");
            sectionButton.addEventListener("click", function (event) {
                let data = {
                    givenName: givenName.value,
                    sn: surName.value,
                    mail: mail.value,
                    mobile: phone.value,
                    password: password1.value
                };
                event.preventDefault();
                DomHelper.resetFormInvalidMessages(formNode);
                let isValid = true;
                try {
                    validateRegisterMail(mail.value);
                }
                catch (e) {
                    isValid = false;
                    const message = e.message;
                    DomHelper.addInvalidMessage(formNode, mail, message);
                }
                if (givenName.value == "") {
                    isValid = false;
                    DomHelper.addInvalidMessage(formNode, givenName, "Der Vorname darf nicht leer sein.");
                }
                if (surName.value == "") {
                    isValid = false;
                    DomHelper.addInvalidMessage(formNode, surName, "Der Nachname darf nicht leer sein.");
                }
                if (password1.value === "") {
                    isValid = false;
                    DomHelper.addInvalidMessage(formNode, password1, "Das Passwort darf nicht leer sein.");
                }
                if (password2.value === "") {
                    isValid = false;
                    DomHelper.addInvalidMessage(formNode, password2, "Bitte bestätigen Sie Ihr Passwort.");
                }
                if (password1.value !== password2.value) {
                    isValid = false;
                    DomHelper.addInvalidMessage(formNode, password2, "Die Passwörter stimmen nicht überein.");
                }
                event.preventDefault();
                if (isValid) {
                    sendBackendData('', `/public/invitation/${invitation.id}`, "POST", 'application/json', "", data, (response) => {
                        console.log("response", response);
                        const responseData = JSON.parse(response.target.response);
                        if (responseData.status == 0) {
                            open("https://chat.open-diakonie.de", "_self");
                        }
                        else {
                            alert("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.");
                        }
                    });
                }
            });
        }
    }
}
function isDomainAvailable(mail) {
    return !RESTRICTED_MAIL_DOMAINS.some(domain => mail.endsWith(`@${domain}`));
}
function validateRegisterMail(mail) {
    if (!isDomainAvailable(mail))
        throw new Error(`Für diese Mailadresse ist keine Selbstregistrierung möglich.<br> In der Regel besteht ihr Account bereits. Bitte versuchen Sie es über den Weg <a href=${KEYCLOAK_ACCOUNT_URI}>Passwort vergessen.</a> `);
    return true;
}
function renderCMDBForm() {
    if (DEBUG)
        console.log("-->renderCMDBForm");
    DomHelper.setHeaderTitle("open-diakonie.de", "CMDB");
}
function renderDefault() {
    if (DEBUG)
        console.log("renderDefault");
}
